import { Navigate } from "react-router-dom";
import { getAccessToken } from "../utils/fetchFunctions";
import { getUserRole } from "../utils/jwtUtils";

const ProtectedAdminRoute = ({ children }) => {
  const token = getAccessToken();
  const role = getUserRole();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
